import { axios, getHeaders } from './config';
import Cookies from 'js-cookie';
import { cookieConsts, FRONTEND_DASHBOARDS } from '../core/constants';
import jwt_decode from 'jwt-decode';

export const verifyAuthTokenFromCookie = () => {
	const tokenString = Cookies.get(cookieConsts.userCookieKey);
	if (tokenString) {
		const tokenObject = JSON.parse(tokenString);
		const auth = tokenObject && tokenObject.authToken.length > 0;
		return auth;
	} else {
		return false;
	}
};

export const getUserTokenFromCookie = () => {
	const tokenString = Cookies.get(cookieConsts.userCookieKey);

	if (tokenString) {
		const tokenObject = JSON.parse(tokenString);
		return tokenObject.authToken;
	} else {
		return null;
	}
};

export const getUserDataFromToken = () => {
	const token = getUserTokenFromCookie();
	const userData = token && jwt_decode(token);
	if (userData) return userData;
	return null;
};

export const register = (data) => {
	return axios.post('/auth/signup', data);
};

export const login = (data) => {
	return axios.post('/auth/login', data);
};

export const logout = () => {
	return axios.get('/auth/logout');
};

export const getActrlDoc = (abortSignal) => {
	if (abortSignal instanceof AbortSignal) {
		return axios.get('/cb/actrlDoc', { signal: abortSignal });
	}
	return axios.get('/cb/actrlDoc');
};

export const sendVerificationCode = (values) => {
	values = { ...values, dashboard: FRONTEND_DASHBOARDS.FRAMERATE_DEFAULT_DASHBOARD };
	return axios.post(`/auth/send-verification`, values);
};

export const verifyCode = (values) => {
	return axios.post(`/auth/verify-code`, values);
};

export const updatePassword = (values) => {
	return axios.post(`/auth/update-password`, values);
};
